$(function($){/*jQuery*/

//page scroll
	var $headerOuterHeight = $('#header-bulgaria').outerHeight();
	$('a[href^="#"]').click(function(){
		if ($(this).hasClass('noscroll')) {
			return false;
		}else{
			var href= $(this).attr('href');
			var target = $(href == '#' || href == '' ? 'html' : href);
			var position = target.offset().top-$headerOuterHeight; //ヘッダの高さ分位置をずらす
			$('html, body').animate({scrollTop:position}, 550, 'swing');
			return false;
		}
	});

	//mousewheel & tap scroll stop
	$(window).on({
	  'mousewheel': function(){$('html:animated,body:animated').stop();},
	  'touchstart': function(){$('html:animated,body:animated').stop();}
	});

//splash
	$('.onSplash').mouseover(
		function(){ $(this).stop().css({'opacity':0.7}).animate({'opacity':1},400);
	});

//onAniOver
	$('.onAniOver').hover(
		function(){$(this).stop().animate({'opacity':0.7},400);},
		function(){$(this).stop().animate({'opacity':1});}
	);

//onOver
	$('.onOver').hover(
		function() {$(this).css({'opacity':0.7});},
		function() {$(this).css({'opacity':1});}
	);

//image-replace-over
	$('.onImgOver').each(function() {
		var _image = this.src;
		var _extension = _image.substr(_image.lastIndexOf("."), _image.length-1);
		var _imageOver = _image.replace(_extension, "-over"+_extension);
		new Image().src = _imageOver;
		$(this).hover(
			function(){this.src = _imageOver;},
			function(){this.src = _image;}
		);
	});

//image-retina
	var _agent = navigator.userAgent;
	if(_agent.search(/iPad/) !== -1){
		$(".x2").each(function() {
			var _image = this.src;
			var _extension = _image.substr(_image.lastIndexOf("."), _image.length-1);
			this.src = _image.replace(_extension, "@2x"+_extension);
		});
	}

//window-open
  var newWindowSizeArray = [ "width=200,height=200","width=300,height=400,scrollbars=yes" ];
  $(function(){
    $('.windowOpen').click(function (event){
      var url = $(this).attr("href");
      var _windowName = "popUp";
      var _windowSize = newWindowSizeArray[ $(this).attr("rel") ];
      window.open(url, _windowName, _windowSize);
      event.preventDefault();
    });
  });

//animate
	$('#nav').on('click',function(){
		var ul = $('ul',this);
		if(ul.hasClass('on')){
			$('ul',this).removeClass('on');
		}else{
			$('ul',this).addClass('on');
		}
	});

//product関連商品
	$(window).on('load', function() {
		var url = window.location.pathname; //表示しているペーじのURL

    //自分自身へのリンクは非表示
		$('.relation-list > li > a[href="'+url+'"]').parent().remove();

		//重複している関連商品は非表示
		var arrayURL = []; //配列を用意
		$('.relation-list > li').each(function(){
			var hrefs = $("a",this).attr("href"); //それぞれのURL取得
			arrayURL.push(hrefs);//配列にプッシュ（格納）する
			var duplicateURL = arrayURL.filter(function (x, i, self) { //配列の中から、重複するURLを抽出し、duplicateURL に代入する。
			    return self.indexOf(x) !== self.lastIndexOf(x);
			});
			if(duplicateURL.indexOf(hrefs) >= 0){ //もし重複するURLリストの中のURLを持つ$('.relation-list > li')は除去する。
				$(this).remove();
			}
    });

  });

	//右クリック制御
	//alert(document.domain+"と"+window.location.hostname);
	var nowDomain = document.domain;
	if(nowDomain.match('test.meijibulgariayogurt.com')||nowDomain.match('stg.meijibulgariayogurt.com')||nowDomain.match('www.meijibulgariayogurt.com')) { //開発の便宜上、drink-yogurt直下ディレクトリでの、右クリック禁止を一時的に解除。
		$(document).on("contextmenu", function() {
			return false;
		});
	}

	//IE
	var ua = navigator.userAgent.toLowerCase();
	var ver = navigator.appVersion.toLowerCase();
	// IE(11以外)
	var isMSIE = (ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);
	// IE11
	var isIE11 = (ua.indexOf('trident/7') > -1);
	// Edge
	var isEdge = (ua.indexOf('edge') > -1);
	// IE
	var isIEnotEdge = isMSIE || isIE11;
	var isAllIE = isMSIE || isIE11 || isEdge;
	if(isIEnotEdge) {
    $("body").addClass('ieStyle')
	} else if(isEdge) {
    $("body").addClass('edgeStyle')
	}

});/*end jQuery*/
